import { render, staticRenderFns } from "./PlaybackSpeedControl.vue?vue&type=template&id=454a51dd&scoped=true&"
import script from "./PlaybackSpeedControl.vue?vue&type=script&lang=js&"
export * from "./PlaybackSpeedControl.vue?vue&type=script&lang=js&"
import style0 from "./PlaybackSpeedControl.vue?vue&type=style&index=0&id=454a51dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a51dd",
  null
  
)

export default component.exports